import PropTypes from 'prop-types'


export const model = [{
  key: 'id',
  label: 'ID',
  prop: {
    type: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    value: '',
  }
}, {
  key: 'thirdPartyNumber',
  label: `Fleet`,
  column: {
    visible: true,
    width: 80,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
},
{
  key: 'requestDate',
  label: 'Date',
  column: {
    visible: true,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
},
{
  key: 'agreementNumber',
  label: 'Agreement Number',
  column: {
    visible: true,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
},
{
  key: 'rego',
  label: 'Rego',
  column: {
    visible: true,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'vehicle',
  label: 'Vehicle',
  column: {
    visible: true,
    width: 120,
    sortable: false,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'odometer',
  label: 'Odometer',
  column: {
    visible: true,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'requestRucKm',
  label: 'Req RUC(km)',
  column: {
    visible: false,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'maturityDate',
  label: 'Maturity Date',
  column: {
    visible: true,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'controller',
  label: 'Controller',
  column: {
    visible: true,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'costCentre',
  label: 'Cost Centre',
  column: {
    visible: true,
    width: 120,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'requestSource',
  label: 'Request Source',
  column: {
    visible: true,
    width: 160,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'requestorDriverName',
  label: 'Requestor Name',
  column: {
    visible: true,
    width: 160,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'requestorDriverEmail',
  label: 'Requestor Email',
  column: {
    visible: true,
    width: 240,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'labelDeliveryAddress',
  label: 'Label Delivery Address',
  column: {
    visible: true,
    width: 200,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}, {
  key: 'comments',
  label: 'Comments',
  column: {
    visible: true,
    width: 200,
  },
  prop: {
    type: PropTypes.string,
    value: '',
  }
}]

const data = {
  title: 'RUC Requests Summary',
  breadcrumbs: null,
  backgroundImage: 'url("/static/images/backgrounds/bg4.png")',
  idKey: 'id',
  api: {
    filter: '/filteroptions/vehiclerucrequest',
    resource: `/VehicleRucRequest/GetVehicleRucRequest`,
    download: `/download/VehicleRucRequest`,
  },
  model,
  headers: [
    'thirdPartyNumber', 'requestDate', 'agreementNumber', 'rego', 'vehicle', 'odometer', 'requestRucKm', 'maturityDate', 'controller', 'costCentre', 'requestSource', 'requestorDriverName', 'requestorDriverEmail', 'labelDeliveryAddress', 'comments',
  ],
  filters: [{
    key: 'fleetId',
    label: 'Fleet',
    prop: {
      type: PropTypes.string,
      value: '',
    }
  }, {
    key: 'costCentre',
    label: 'Cost Centre',
    prop: {
      type: PropTypes.string,
      value: '',
    }
  }, {
    key: 'fleetController',
    label: 'Controller',
    prop: {
      type: PropTypes.string,
      value: '',
    }
  }],
}


export default data
